import { render, staticRenderFns } from "./MenuTop.vue?vue&type=template&id=3b976906&scoped=true&"
import script from "./MenuTop.vue?vue&type=script&lang=js&"
export * from "./MenuTop.vue?vue&type=script&lang=js&"
import style0 from "./MenuTop.vue?vue&type=style&index=0&id=3b976906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b976906",
  null
  
)

export default component.exports